<template>
  <b-row>
    <b-col cols="12" class="mt-3">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">商品分類銷售分析</span>
          </div>
          <!--div>
            <b-form-datepicker id="sell-datepicker-start" class="ml-3 mw-15 float-right"></b-form-datepicker>
            <span class="ml-2 mt-2 float-right"><p>至</p></span>
            <b-form-datepicker id="sell-datepicker-end" class="ml-3 mw-15 float-right"></b-form-datepicker>
            <span class="ml-2 mt-2 float-right"><p>從</p></span>
          </div-->
          <b-button-group class="ml-3 float-right">
            <b-button variant="primary" class="border" @click="setAnalysisInterval(-7)" :class="{active:daysBeforeAnalysisEnd===-7}">最近7天</b-button>
            <b-button variant="primary" class="border" @click="setAnalysisInterval(-30)" :class="{active:daysBeforeAnalysisEnd===-30}">最近30天</b-button>
            <b-button variant="primary" class="border" @click="setAnalysisInterval(-60)" :class="{active:daysBeforeAnalysisEnd===-60}">最近60天</b-button>
          </b-button-group>
          <b-dropdown split :split-href="classifyCountDownloadLink('xlsx')" variant="light" split-variant="light" class="float-right" text="匯出數據">
            <b-dropdown-item :href="classifyCountDownloadLink('xlsx')" target="_blank">xlsx</b-dropdown-item>
            <b-dropdown-item :href="classifyCountDownloadLink('ods')" target="_blank">ods</b-dropdown-item>
            <b-dropdown-item :href="classifyCountDownloadLink('json')" target="_blank">json</b-dropdown-item>
          </b-dropdown>
        </template>
        <pie-chart v-if="analysisChartData" :chart-data="analysisChartData"></pie-chart>
        <b-table
          class="mt-5"
          responsive
          :busy="isAnalysisDataLoading"
          :items="analysisData"
          :fields="analysisTableFields"
          head-variant="light"
          show-empty
          empty-text="無數據"
          bordered
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
      </b-card>
      <b-card header-class="custom-header-bg" class="mt-5">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">商品銷售狀況</span>
          </div>
          <!--div>
            <b-form-datepicker id="sell-datepicker-start" class="ml-3 mw-15 float-right"></b-form-datepicker>
            <span class="ml-2 mt-2 float-right"><p>至</p></span>
            <b-form-datepicker id="sell-datepicker-end" class="ml-3 mw-15 float-right"></b-form-datepicker>
            <span class="ml-2 mt-2 float-right"><p>從</p></span>
          </div-->
          <b-button-group class="ml-3 float-right">
            <b-button variant="primary" class="border" @click="setSellStateInterval(-7)" :class="{active:daysBeforeSellStateEnd===-7}">最近7天</b-button>
            <b-button variant="primary" class="border" @click="setSellStateInterval(-30)" :class="{active:daysBeforeSellStateEnd===-30}">最近30天</b-button>
            <b-button variant="primary" class="border" @click="setSellStateInterval(-60)" :class="{active:daysBeforeSellStateEnd===-60}">最近60天</b-button>
          </b-button-group>
          <b-dropdown split :split-href="catalogCaleDownloadLink('xlsx')" variant="light" split-variant="light" class="float-right" text="匯出數據">
            <b-dropdown-item :href="catalogCaleDownloadLink('xlsx')" target="_blank">xlsx</b-dropdown-item>
            <b-dropdown-item :href="catalogCaleDownloadLink('ods')" target="_blank">ods</b-dropdown-item>
            <b-dropdown-item :href="catalogCaleDownloadLink('json')" target="_blank">json</b-dropdown-item>
          </b-dropdown>
        </template>
        <b-table
          class="mt-2"
          responsive
          :busy="isSellStateDataLoading"
          :items="sellStateData"
          :fields="sellStateTableFields"
          head-variant="light"
          show-empty
          empty-text="無數據"
          bordered
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import moment from 'moment'
import QueryString from 'querystring'
import PieChart from '../../library/PieChart.js'
const backgroundColor = [
  '#41B883',
  '#E46651',
  '#00D8FF',
  '#DD1B16',
  '#E46651',
  '#00D8FF',
  '#DD1B16'
]
export default {
  components: {
    PieChart
  },
  data () {
    return {
      isAnalysisDataLoading: false,
      analysisEnd: null,
      daysBeforeAnalysisEnd: -7,
      isSellStateDataLoading: false,
      sellStateEnd: null,
      daysBeforeSellStateEnd: -7,
      analysisChartData: false,
      analysisData: [],
      sellStateData: []
    }
  },
  computed: {
    analysisReqData () {
      const end = this.analysisEnd
      const start = moment(end).day(this.daysBeforeAnalysisEnd)
      return {
        start: start.format('YYYYMMDD'),
        end: end.format('YYYYMMDD')
      }
    },
    analysisTableFields () {
      return [
        { key: 'name', label: '分類名稱' },
        { key: 'amount', label: '銷售總數' },
        { key: 'percentage', label: '銷售比例' },
        { key: 'total', label: '銷售總額($)' }
      ]
    },
    sellStateReqData () {
      const end = this.sellStateEnd
      const start = moment(end).day(this.daysBeforeAnalysisEnd)
      return {
        start: start.format('YYYYMMDD'),
        end: end.format('YYYYMMDD')
      }
    },
    sellStateTableFields () {
      return [
        { key: 'name', label: '商品名稱' },
        { key: 'viewCount', label: '商品瀏覽人數' },
        { key: 'buyerCount', label: '商品購買人數' },
        { key: 'buyAmount', label: '商品銷售數量' },
        { key: 'conversionRate', label: '轉換率' },
        { key: 'buyTotalPrice', label: '銷售金額' }
      ]
    }
  },
  methods: {
    setAnalysisInterval (n) {
      this.analysisEnd = moment()
      this.daysBeforeAnalysisEnd = n
      this.drawAnalysisView()
    },
    async drawAnalysisView () {
      /**
       * array formart
       * @type {String} id 分類ID
       * @type {String} name 分類名稱
       * @type {Number} amount 販賣累積數量
       * @type {Number} total 販賣累積金額
       */
      this.isAnalysisDataLoading = true
      try {
        const query = `?${QueryString.stringify(this.analysisReqData)}`
        const { data: array } = await this.$api.GetClassifyCount(query)
        const labels = array.map(item => item.name)
        const datasets = [{
          data: array.map(item => item.amount),
          backgroundColor
        }]
        this.analysisChartData = { labels, datasets }
        const amountSum = array.reduce((prevSum, item) => (prevSum += item.amount), 0)
        array.forEach(item => {
          item.percentage = `${(item.amount / amountSum * 100).toFixed(2)}%`
        })
        this.analysisData = array
      } catch (err) {
        console.log(err)
      }
      this.isAnalysisDataLoading = false
    },
    setSellStateInterval (n) {
      this.sellStateEnd = moment()
      this.daysBeforeSellStateEnd = n
      this.drawSellStateView()
    },
    async drawSellStateView () {
      /**
       * array format
       * @type {String} id 編號
       * @type {String} name 名稱
       * @type {Number} viewCount 查閱人數
       * @type {Number} buyerCount 購買者人數
       * @type {Number} buyAmount 總售出量
       * @type {Number} buyTotalPrice 總售出價
       */
      this.isSellStateDataLoading = true
      try {
        const query = `?${QueryString.stringify(this.sellStateReqData)}`
        const { data: array } = await this.$api.GetCatalogCale(query)
        array.forEach(item => {
          item.conversionRate = `${(item.buyerCount / item.viewCount * 100).toFixed(2)}%`
        })
        this.sellStateData = array
      } catch (err) {
        console.log(err)
      }
      this.isSellStateDataLoading = false
    },
    classifyCountDownloadLink (format) {
      const data = { format, ...this.analysisReqData }
      const query = `?${QueryString.stringify(data)}`
      return this.$api.urlClassifyCount(query)
    },
    catalogCaleDownloadLink (format) {
      const data = { format, ...this.sellStateReqData }
      const query = `?${QueryString.stringify(data)}`
      return this.$api.urlCatalogCale(query)
    }
  },
  created () {
    this.setAnalysisInterval(-7)
    this.setSellStateInterval(-7)
  }
}
</script>